import { mapGetters } from 'vuex';

export const storeprops = {
	...mapGetters(['isLoggedIn', 'userAuth', 'userInfo', 'filteredProjects',
		'filteredClients', 'clients', 'hasSelectedProject', 'getDashboardDateHorizon'])
};

// const lastTwelveMonths = () => {
// 	const arr = [];
// 	// create a current start date of the 1st of this month
// 	const fistOfThisMonth = moment().set("date", 1);
// 	const startMonth = fistOfThisMonth.subtract(12, "months");
// 	for (let i = 0; i < 12; i++)
// 		arr.push(startMonth.add(1, "months").format("MMM"));
// 	return arr;
// };

// function getSummaryInvoicesPerMonth(dateSpan) {
// 	if (dateSpan == "Last12Month") {
// 		let months = lastTwelveMonths();

// 	}

// }


